/**
 * Felixmate Office Pack (ADR 0070): ilk açılış ve ilk "Fill in" sorusu, ayarlardaki kart. Ürün adı
 * yalnız "Felixmate Office Pack"; LibreOffice adı yalnız lisans satırında, TDF'ye atıf ve "bağlantısı
 * yoktur" bildirimiyle geçer (sahip kararı 2026-10-17, en az risk; sorular.md #622, #623).
 */
export const officePackEn = {
  name: 'Felixmate Office Pack',
  offer: {
    title: 'Download Felixmate Office Pack?',
    body: 'Felixmate Office Pack lets you fill in your company’s Word and Excel forms inside Felixmate, without Microsoft Office. It downloads in the background ({{size}}) and continues where it left off if the connection drops.',
    fillIn:
      'This time the form opens with the program installed on this computer. Once the pack is installed, forms open in Felixmate Office Pack and are added to the record when you close them.',
    download: 'Download',
    later: 'Later',
    close: 'Close',
    approximate: 'about {{size}}',
  },
  card: {
    title: 'Felixmate Office Pack',
    product: 'Product',
    productValue: 'Felixmate Office Pack',
    status: 'Status',
    version: 'Version',
    versionValue: '{{version}}',
    licence: 'Licence',
    licenceValue:
      'Includes LibreOffice {{libreOffice}} by The Document Foundation (MPL-2.0). Not affiliated with The Document Foundation. Source code: api.felixmate.com/updates/office-pack/source',
    size: 'Size',
    sizeValue: '{{download}} download · {{disk}} on this computer',
    diskValue: '{{disk}} on this computer',
    progress: '{{received}} of {{total}}',
    help: 'Fills in Word and Excel forms inside Felix. When you save and close a form, it is added to the record with a PDF copy.',
    states: {
      notInstalled: 'Not installed',
      installed: 'Installed',
      update: 'Update {{version}} available',
      downloading: 'Downloading {{percent}} %',
      paused: 'Paused',
      waiting: 'Waiting for connection',
      installing: 'Installing…',
      error: 'Could not install',
      unavailable: 'Not available in this installation',
    },
    download: 'Download',
    resume: 'Resume',
    pause: 'Pause',
    remove: 'Remove',
    removeTitle: 'Remove Felixmate Office Pack?',
    removeBody:
      'Word and Excel forms will open with the program installed on this computer again. You can download the pack again at any time.',
    removeConfirm: 'Remove',
    cancel: 'Cancel',
    errors: {
      IN_USE: 'A form is still open in Felixmate Office Pack. Save and close it first.',
      APP_TOO_OLD: 'This pack needs a newer Felixmate. Update Felixmate first.',
      HASH_MISMATCH: 'The download was damaged and has been deleted. Select Download to try again.',
      SIZE_MISMATCH: 'The download was damaged and has been deleted. Select Download to try again.',
      BAD_SIGNATURE: 'The pack on the server is not signed by Felixmate. It was not installed.',
      generic: 'Felixmate Office Pack could not be installed. Select Download to try again.',
    },
  },
};

export type OfficePackResources = typeof officePackEn;

export const officePackTr: OfficePackResources = {
  name: 'Felixmate Office Pack',
  offer: {
    title: 'Felixmate Office Pack indirilsin mi?',
    body: 'Felixmate Office Pack, şirketinizin Word ve Excel formlarını Microsoft Office olmadan Felixmate içinden doldurmanızı sağlar. Arka planda iner ({{size}}); bağlantı koparsa kaldığı yerden sürer.',
    fillIn:
      'Bu sefer form bu bilgisayarda kurulu programla açılır. Paket kurulunca formlar Felixmate Office Pack’te açılır ve kapatınca kayda eklenir.',
    download: 'İndir',
    later: 'Sonra',
    close: 'Kapat',
    approximate: 'yaklaşık {{size}}',
  },
  card: {
    title: 'Felixmate Office Pack',
    product: 'Ürün',
    productValue: 'Felixmate Office Pack',
    status: 'Durum',
    version: 'Sürüm',
    versionValue: '{{version}}',
    licence: 'Lisans',
    licenceValue:
      'The Document Foundation’ın LibreOffice {{libreOffice}} yazılımını içerir (MPL-2.0). The Document Foundation ile bağlantısı yoktur. Kaynak kod: api.felixmate.com/updates/office-pack/source',
    size: 'Boyut',
    sizeValue: '{{download}} indirme · bu bilgisayarda {{disk}}',
    diskValue: 'bu bilgisayarda {{disk}}',
    progress: '{{received}} / {{total}}',
    help: 'Word ve Excel formlarını Felix içinden doldurur. Formu kaydedip kapatınca form, PDF kopyasıyla kayda eklenir.',
    states: {
      notInstalled: 'Kurulu değil',
      installed: 'Kurulu',
      update: '{{version}} güncellemesi var',
      downloading: 'İniyor %{{percent}}',
      paused: 'Duraklatıldı',
      waiting: 'Bağlantı bekleniyor',
      installing: 'Kuruluyor…',
      error: 'Kurulamadı',
      unavailable: 'Bu kurulumda yok',
    },
    download: 'İndir',
    resume: 'Sürdür',
    pause: 'Duraklat',
    remove: 'Kaldır',
    removeTitle: 'Felixmate Office Pack kaldırılsın mı?',
    removeBody:
      'Word ve Excel formları yeniden bu bilgisayarda kurulu programla açılır. Paketi istediğiniz zaman yeniden indirebilirsiniz.',
    removeConfirm: 'Kaldır',
    cancel: 'Vazgeç',
    errors: {
      IN_USE: 'Felixmate Office Pack’te hâlâ açık bir form var. Önce kaydedip kapatın.',
      APP_TOO_OLD: 'Bu paket daha yeni bir Felixmate ister. Önce Felixmate’ı güncelleyin.',
      HASH_MISMATCH: 'İndirilen dosya bozuktu ve silindi. Yeniden denemek için İndir’i seçin.',
      SIZE_MISMATCH: 'İndirilen dosya bozuktu ve silindi. Yeniden denemek için İndir’i seçin.',
      BAD_SIGNATURE: 'Sunucudaki paket Felixmate imzası taşımıyor; kurulmadı.',
      generic: 'Felixmate Office Pack kurulamadı. Yeniden denemek için İndir’i seçin.',
    },
  },
};
